import { createStore } from 'vuex';

import bootstrap from 'bootstrap/dist/js/bootstrap.min.js';

import admin from './modules/admin/index';
import bizRequest from './modules/bizRequest/index';
import bizTransaction from './modules/bizTransaction/index';
import coupon from './modules/coupon/index';
import dashboard from './modules/dashboard/index';
import favProduct from './modules/favProduct/index';
import favStore from './modules/favStore/index';
import review from './modules/review/index';
import cs from './modules/cs/index';
import order from './modules/order/index';
import product from './modules/product/index';
import recent from './modules/recent/index';
import store from './modules/store/index';
import layout from './modules/layout/index';
import constant from './modules/constant/index';
import chat from './modules/chat/index';
import common from './modules/common/index';
import productCategory from './modules/productCategory/index';
import locale from './modules/locale/index';
import pos from './modules/pos/index';

import createPersistedState from 'vuex-persistedstate';
import { createLogger } from 'vuex/dist/vuex.esm-browser.prod';
const embeddedLogger = createLogger({
  filter(mutation, stateBefore, stateAfter) {
    if (!mutation.type.includes('common') && !mutation.type.includes('layout')) {
      console.debug(`::::::::: ${mutation.type.substr(0, mutation.type.lastIndexOf('/'))} :::::::::`);
      console.debug('BEFORE :', stateBefore[mutation.type.substr(0, mutation.type.lastIndexOf('/'))]);
      console.debug('AFTER :', stateAfter[mutation.type.substr(0, mutation.type.lastIndexOf('/'))]);
    }
  },
  logger: console
});
export default createStore({
  state: {
    bootstrap
  },
  modules: {
    layout,
    constant,
    common,
    bizRequest,
    bizTransaction,
    coupon,
    dashboard,
    favProduct,
    favStore,
    review,
    cs,
    productCategory,
    order,
    product,
    recent,
    store,
    admin,
    chat,
    locale,
    pos
  },
  plugins: [
    createPersistedState({
      paths: ['admin', 'constant', 'common', 'store.detail', 'locale']
    })
  ]
});
